import createIcon from '../createIcon';

export const CancelIcon = createIcon({
  path: (
    <path
      d="M36.5995 11.4195C35.8195 10.6395 34.5595 10.6395 33.7795 11.4195L23.9995 21.1795L14.2195 11.3995C13.4395 10.6195 12.1795 10.6195 11.3995 11.3995C10.6195 12.1795 10.6195 13.4395 11.3995 14.2195L21.1795 23.9995L11.3995 33.7795C10.6195 34.5595 10.6195 35.8195 11.3995 36.5995C12.1795 37.3795 13.4395 37.3795 14.2195 36.5995L23.9995 26.8195L33.7795 36.5995C34.5595 37.3795 35.8195 37.3795 36.5995 36.5995C37.3795 35.8195 37.3795 34.5595 36.5995 33.7795L26.8195 23.9995L36.5995 14.2195C37.3595 13.4595 37.3595 12.1795 36.5995 11.4195Z"
      fill="currentColor"
    />
  ),
});
